export default __webpack_public_path__ + "static/media/img_134.2db380cf.jpg";